<template>
  <div class="main-chapter1">
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 3
    </div>

    <div class="chapter-title">Общие сведения</div>
    <n-items v-if="project">
      <n-button v-if="checkSign('tech')" @click="$var('tech', true)">Подписать</n-button>
      <n-button v-if="checkSign('executor')" @click="$var('exec', true)">Подписать</n-button>
      <n-input title="Наименование организации, выполняющей работы" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Наименование объекта строительства" v-bind="$form.input('projectTitle')" :text="!editable" />
      <n-select :data="dataResponsible" title="Должность, фамилия, инициалы и подпись ответственного за сварочные работы и ведение журнала"
                v-bind="$form.input('executorUser', 'select')" :disabled="!!journal.data.executorUser.name || !editable" />
      <c-journal-sign :sign="getSign(journal, 'executor')" />
      <n-input title="Организация, разработавшая проектную документацию, чертежи КМ, КЖ" v-bind="$form.input('projectorDoc')" :text="!editable" />
      <n-input title="Шифр проекта" v-bind="$form.input('cipherProject1')" :text="!editable" />
      <n-input title="Организация, разработавшая проект производства сварочных работ" v-bind="$form.input('projectorWelding')" :text="!editable" />
      <n-input title="Шифр проекта" v-bind="$form.input('cipherProject')" :text="!editable" />
      <n-input title="Предприятие, изготовившее конструкции" v-bind="$form.input('dealer')" :text="!editable" />
      <n-input title="Шифр заказа" v-bind="$form.input('cipherOrder')" :text="!editable" />
      <n-input title="Заказчик (организация)" v-bind="$form.input('tech')" :text="!editable" />
      <n-select :data="data" title="Должность, фамилия, инициалы и подпись руководителя (представителя) технического надзора"
                v-bind="$form.input('techUser', 'select')" :disabled="!!journal.data.techUser.name || !editable" />
      <c-journal-sign :sign="getSign(journal, 'tech')" />
      <n-datepicker title="Журнал начат" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-datepicker title="Журнал окончен" v-bind="$form.input('endedAt')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <c-modal-journal-do-sign v-if="$var('tech')" @close="$var('tech', false)" @submit="(s) => doSign('tech', s)" />
    <c-modal-journal-do-sign v-if="$var('exec')" @close="$var('exec', false)" @submit="(s) => doSign('executor', s)" />
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
import CModalJournalDoSign from '../../../components/journal/ModalDoSign'
import CJournalSign from '../../../components/journal/Sign'

export default {
  name: 'MainChapter1',
  components: { CModalJournalDoSign, CJournalSign, },
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data() {
    return {
      data: [],
      dataResponsible: [],
    }
  },
  computed: {},
  created() {
    this.$form.init(this.journal.data)
    this.loadTech()
    this.loadExec()
  },
  methods: {
    checkSign(name) {
      if (name === 'tech') {
        return this.journal.data.techUser.name === $app.auth.user().id && this.getSign(this.journal, 'tech').isApproved !== true
      } else {
        return this.journal.data.executorUser.name === $app.auth.user().id && this.getSign(this.journal, 'executor').isApproved !== true
      }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
    doSign(name, sign) {
      this.$var('load', true)
      $api.journals.welding.doSign(this.journal.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadTech() {
      $api.data.get(this.project.id, 'participants,tech,sub,all').then((response) => {
        this.data = response.data.content
      })
    },
    loadExec() {
      $api.data.get(this.project.id, 'participants,executor,gen,all').then((response) => {
        this.dataResponsible = response.data.content
      })
    },
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
